import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled, { css } from "styled-components";

export const MobileImage = styled.img`
  display: none;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    display: block;
    object-fit: contain;
    text-align: center;
    max-height: 560px;
    width: auto;
    min-height: 318px;
    padding: 0 16px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    min-height: unset;
    padding: 0;
  }
`;

export const SlideContentContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    padding-bottom: 0;
  }
`;

export const SlideContentInsideWrap = styled.div`
  max-height: 720px;
  max-width: 1920px;
  min-height: fit-content;
  position: relative;
  width: 100vw;
  padding: 30px 0 70px;
  margin-top: 20px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    margin-top: 0;
  }
`;

export const CarouselWrapper = styled.div`
  aspect-ratio: 1328 / 620;
  max-width: 1328px;
  background: #f9f9fa;
  border-radius: 16px;
  width: 100%;
  padding: 0 32px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    aspect-ratio: auto;
    display: flex;
    flex-direction: column;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    padding: 0;
    gap: 16px;
    border-radius: 0;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    border-radius: 0;
    gap: 4px;
  }
`;

export const SlideDescription = styled.p`
  color: #808893;
  font-size: 16px;
  line-height: 24px;
  margin: 0;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 14px;
  }
`;

export const SlideContainer = styled.div`
  border-radius: 6px;
  height: 100%;
  max-width: 1200px;
  padding: 32px;
  width: 100%;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    height: auto;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    padding: 16px;
  }
`;

export const VideoBackground = styled.video`
  height: 100%;
  left: 0;
  object-fit: unset;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 406px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    max-width: 100%;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    gap: 16px;
  }
`;

export const SlideHeader = styled.div`
  border-bottom: 1px solid #dee0e3;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    gap: 8px;
  }
`;

export const SlideTitle = styled.h3`
  color: #212427;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 21px;
  }
`;

export const SlidesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    gap: 12px;
  }
`;

export const SlideText = styled.p`
  color: #50565e;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;

  @media ${BREAKPOINTS.DESKTOP_AND_DOWN} {
    br {
      display: none;
    }
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    font-size: 14px;
  }
`;

export const SlideItem = styled.div<{ $isActive: boolean }>`
  align-items: center;
  display: flex;
  gap: 16px;
  width: 100%;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    gap: 12px;
  }

  svg {
    color: #808893;
    flex-shrink: 0;
    height: 40px;
    width: 40px;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      ${SlideText} {
        color: ${({ theme }) => theme.colors.primaryBlue};
      }

      svg {
        color: ${({ theme }) => theme.colors.primaryBlue};
      }
    `}
`;
